import z from 'zod';

export const optionalCustomObject = z
  .record(z.any())
  .nullish()
  .transform((val) => val || null);
